module.exports = __webpack_public_path__ + "img/evolve-pic-3.4d9e7c7c.jpg";